import clsx from "clsx";
import type { ReactNode } from "react";

/** Abschnitts-Karte wie `.ts-flow-card` in der klassischen Stundennachweis-UI. */
export function TimesheetFlowCard({
  title,
  children,
  className,
  titleClassName,
}: {
  title?: string;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
}) {
  return (
    <section
      className={clsx(
        "rounded-[0.9rem] border border-separator/80 bg-fill-quaternary/25 p-3 dark:bg-fill-quaternary/15",
        className,
      )}
    >
      {title ? (
        <h3 className={clsx("mb-3 text-base font-semibold text-label", titleClassName)}>{title}</h3>
      ) : null}
      {children}
    </section>
  );
}
